import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  buttonItem: {
    width: '100%',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    background: '#fff',
    padding: 2,
    borderRadius: 5,
    transition: 'all .2s ease-in-out',
    '&:hover': {
      background: '#f0f0f0',
      filter: 'brightness(.9)'
    }
  }
});
